
import SaveIcon from './Save'
import PlusIcon from './PlusIcon'
import ArrowDownIcon from './ArrowDownIcon'
import AnalyticsIcon from './AnalyticsIcon'
import BellIcon from './BellIcon'
import CheckListIcon from './CheckListIcon'
import ChevronLeftIcon from './ChevronLeftIcon'
import ChevronRightIcon from './ChevronRightIcon'
import CloserIcon from './CloserIcon'
import CodeIcon from './CodeIcon'
import ConfigurationIcon from './ConfigurationIcon'
import EditIcon from './EditIcon'
import EyeFillIcon from './EyeFillIcon'
import FolderIcon from './FolderIcon'
import HomeIcon from './HomeIcon'
import ImageIcon from './ImageIcon'
import MobileIcon from './MobileIcon'
import PauseFillIcon from './PauseFillIcon'
import PaymentIcon from './PaymentIcon'
import PlaceholderIcon from './PlaceholderIcon'
import PlusRoundedIcon from './PlusRoundedIcon'
import QuestionMarkIcon from './QuestionMarkIcon'
import SearchIcon from './SearchIcon'
import SliderVerticalIcon from './SliderVerticalIcon'
import StoreIcon from './StoreIcon'
import TrashIcon from './TrashIcon'
import SaveSolidIcon from './SaveSolidIcon'
import CloudUploadIcon from './CloudUploadIcon'
import XIcon from './XIcon'
import CheckCircleIcon from './CheckCircleIcon'
import PhotographSolidIcon from './PhotographSolidIcon'
import UserIcon from './UserIcon'
import ArrowNarrowRightIcon from './ArrowNarrowRightIcon'
import PlayIcon from './PlayIcon'
import CheckIcon from './CheckIcon'
import ArrowTopRightSquareIcon from './ArrowTopRightSquareIcon'
import LockClosedSolidIcon from './LockClosedSolidIcon'
import BracesIcon from './BracesIcon'
import DocumentIcon from './DocumentIcon'
import ViewColumnsIcon from './ViewColumnsIcon'
import DocumentTextIcon from './DocumentTextIcon'
import DocumentPlusIcon from './DocumentPlusIcon'
import PuzzlePieceIcon from './PuzzlePieceIcon'
import PaintBrushIcon from './PaintBrushIcon'
import StackIcon from './StackIcon'
import DashboardIcon from './DashboardIcon'
import CommandLineIcon from './CommandLineIcon'
import ChartBarIcon from './ChartBarIcon'
import CodeBracketSquareIcon from './CodeBracketSquareIcon'
import URLIcon from './URLIcon'
import LightShiningIcon from './LightShiningIcon'
import JournalIcon from './JournalIcon'
import HeartIcon from './HeartIcon'
import ArrowPathIcon from './ArrowPathIcon'
import SwatchIcon from './SwatchIcon'
import LinkIcon from './LinkIcon'
import ArrowSmallRightIcon from './ArrowSmallRightIcon'
import TableCellsIcon from './TableCellsIcon'
import BuildingLibraryIcon from './BuildingLibraryIcon'
import UserGroupIcon from './UserGroupIcon'
import FaceFrownIcon from './FaceFrownIcon'
import DocumentDuplicateIcon from './DocumentDuplicateIcon'
import CalendarIcon from './CalendarIcon'
import NetworkIcon from './NetworkIcon'
import DoubleChevronRightIcon from './DoubleChevronRightIcon'
import ClockIcon from './ClockIcon'
import ChevronTopIcon from './ChevronTopIcon'
import ArrowDownTray from './ArrowDownTray'
import ComputerDesktopIcon from './ComputerDesktopIcon'
import PencilIcon from './PencilIcon'
import PaperAirplaneIcon from './PaperAirplaneIcon'
import EnvelopeIcon from './EnvelopeIcon'
import MagnifyingGlassCircleIcon from './MagnifyingGlassCircleIcon'
import WrenchScrewdriverIcon from './WrenchScrewdriverIcon'
import RollbackIcon from './RollbackIcon'
import ClipboardDocumentIcon from './ClipboardDocumentIcon'
import CircleStackIcon from './CircleStackIcon'
import RocketIcon from './RocketIcon'
import DraggableIcon from './DraggableIcon'
import Square3Stack3DIcon from './Square3Stack3DIcon'

export default {
  SaveIcon,
  PlusIcon,
  ArrowDownIcon,
  AnalyticsIcon,
  BellIcon,
  CheckListIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  CloserIcon,
  CodeIcon,
  ConfigurationIcon,
  EditIcon,
  EyeFillIcon,
  FolderIcon,
  HomeIcon,
  ImageIcon,
  MobileIcon,
  PauseFillIcon,
  PaymentIcon,
  PlaceholderIcon,
  PlusRoundedIcon,
  QuestionMarkIcon,
  SearchIcon,
  SliderVerticalIcon,
  StoreIcon,
  TrashIcon,
  SaveSolidIcon,
  CloudUploadIcon,
  XIcon,
  CheckCircleIcon,
  PhotographSolidIcon,
  UserIcon,
  ArrowNarrowRightIcon,
  PlayIcon,
  CheckIcon,
  ArrowTopRightSquareIcon,
  LockClosedSolidIcon,
  BracesIcon,
  DocumentIcon,
  ViewColumnsIcon,
  DocumentTextIcon,
  DocumentPlusIcon,
  PuzzlePieceIcon,
  PaintBrushIcon,
  StackIcon,
  DashboardIcon,
  CommandLineIcon,
  ChartBarIcon,
  CodeBracketSquareIcon,
  URLIcon,
  LightShiningIcon,
  JournalIcon,
  HeartIcon,
  ArrowPathIcon,
  SwatchIcon,
  LinkIcon,
  ArrowSmallRightIcon,
  TableCellsIcon,
  BuildingLibraryIcon,
  UserGroupIcon,
  FaceFrownIcon,
  DocumentDuplicateIcon,
  CalendarIcon,
  NetworkIcon,
  DoubleChevronRightIcon,
  ClockIcon,
  ChevronTopIcon,
  ArrowDownTray,
  ComputerDesktopIcon,
  PencilIcon,
  PaperAirplaneIcon,
  EnvelopeIcon,
  MagnifyingGlassCircleIcon,
  WrenchScrewdriverIcon,
  RollbackIcon,
  ClipboardDocumentIcon,
  CircleStackIcon,
  RocketIcon,
  DraggableIcon,
  Square3Stack3DIcon
}
